import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import banner from "../assets/image/Banners/banner1.jpg";
import banner2 from "../assets/image/Banners/banner3.png";
import banner3 from "../assets/image/Banners/banner4.jpg";

// Array simples apenas com as imagens
const images = [banner, banner2, banner3];

export default function Carousel() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  return (
   
    // 1. Container ajustado para ocupar a largura total
    <div className="w-full" id="home">
      <div className="relative overflow-hidden">
        <Slider {...settings}>
          {images.map((img, index) => (
            <div key={index}>
              {/* 2. Altura das imagens aumentada */}
              <img 
                src={img} 
                alt={`Slide ${index + 1}`} 
                className="w-full h-80 sm:h-96 md:h-[750px] object-cover" 
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

